import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Layout } from '../components/Layout/Layout';
import { EstimateContainer } from '../../../common/components/redesignComponents/common/Redesign.styles';
import { RiskContainer } from '../../MalattiaProduct/styles/MalattiaResultPage.styles';
import MalattiaModal from '../../MalattiaProduct/components/MalattiaModal';
import MalattiaModalButtons from '../../MalattiaProduct/components/MalattiaModalButtons';
import { confirmAlert } from '../../../common/utils/alerts';
import {
  addBackOfficeQuoteToCart, loadBackOfficeQuotes, removeBackOfficeQuoteFromCart, resetBackOfficeQuotes,
} from '../../../features/backofficeResults/backofficeResultsActions';
import PageLoading from '../../../common/componentsV2/elements/PageLoading';
import { getQuoteTypes } from '../../../features/utilities/utilitiesActions';
import { V2FontImport } from '../../../common/formInputsV2/V2Fonts';
import ResultOverviewRow from '../../../common/components/redesignComponents/ResultPageComponents/v2/ResultOverviewRow';
import MalattiaSummaryCard from '../../../common/components/redesignComponents/ResultPageComponents/v2/MalattiaSummaryCard';
import QuoteCostSummaryCard from '../../../common/components/redesignComponents/ResultPageComponents/v2/QuoteCostSummaryCard';

function BackofficeMalattiaQuotes() {
  const { requestToken } = useParams();
  const state = useSelector((store) => store.backofficeResults.back_office_quotes);
  const {
    loading,
    requestInfo,
    quotes,
    processingQuote,
    addingQuote,
    customer,
    risk_quotations,
  } = state;

  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);

  useEffect(() => {
    loadBackOfficeQuotes(requestToken);
    getQuoteTypes();

    return () => {
      resetBackOfficeQuotes();
    };
  }, []);

  const refresh = () => loadBackOfficeQuotes(requestToken);

  if (loading) {
    return <PageLoading />;
  }

  const fetchQuotes = () => {
    loadBackOfficeQuotes(requestToken);
  };

  const selectQuotation = (quoteId) => {
    confirmAlert('Sei Sicuro di aggiungere questa quotazione?', () => addBackOfficeQuoteToCart(quoteId, fetchQuotes));
  };

  const removeItemFromCart = (quoteId) => {
    confirmAlert('Sei Sicuro di rimuovere questa quotazione?', () => removeBackOfficeQuoteFromCart(quoteId, fetchQuotes));
  };

  const getTotal = () => {
    let quoteInProccessAmount = 0;
    let risksTotalAmount = 0;

    if (processingQuote !== null && processingQuote.amount !== null) {
      quoteInProccessAmount = parseFloat(processingQuote.amount);
    }

    const riskTypes = quoteTypes.filter((t) => t.id !== 'res_civile');

    for (let x = 0; x < riskTypes.length; x++) {
      const type = riskTypes[x];
      if (risk_quotations && risk_quotations[type.id] !== undefined) {
        for (let i = 0; i < risk_quotations[type.id].length; i++) {
          const item = risk_quotations[type.id][i];

          risksTotalAmount += parseFloat(item.amount);
        }
      }
    }

    return (quoteInProccessAmount + risksTotalAmount).toFixed(2);
  };
  return (
    <Layout>
      <V2FontImport />
      <div className="resultsPage mx-auto w-75">
        <ResultOverviewRow>
          <MalattiaSummaryCard
            customer={customer}
            insuranceRequest={requestInfo}
          />
          <QuoteCostSummaryCard
            processingQuote={processingQuote}
            quoteTypes={quoteTypes}
            riskQuotations={risk_quotations}
            getTotal={getTotal}
            rcTypeLabel={processingQuote?.product_name}
          />
        </ResultOverviewRow>
        <div className="row">
          <div className="col-12 ">
            <EstimateContainer>
              <div className="d-flex gap-2 justify-content-end ">
                <div>
                  {/* {localStorage.getItem('quoteNewResult') === 'done' && (
                      <div style={{ cursor: 'pointer' }} onClick={() => firePurchaseTour()}>
                        <button className="btn btn-success px-2 py-1">Tutorial</button>
                      </div>
                    )} */}
                </div>
              </div>
            </EstimateContainer>
          </div>
        </div>
        {quotes && !quotes.res_civile
          && (
            <div className="alert alert-info mx-2" role="alert">
              <h4 className="alert-heading">Aviso!</h4>
              <p className="m-0">Il preventivo non è riuscito per problemi relativi ai dati assicurativi. Si prega di contattare il nostro backoffice per ottenere il preventivo o ulteriori informazioni.</p>
            </div>
          )}

        {quotes && quotes.res_civile
          && (
            <>
              <RiskContainer className="mb-3 pb-3 result-home-third-step">
                {quoteTypes.map((type, index) => (
                  <React.Fragment key={index}>
                    {quotes && quotes[type.id] && (
                      <MalattiaModalButtons
                        insuranceRequest={requestInfo}
                        processingQuote={processingQuote}
                        type={type}
                        removeItemFromCart={removeItemFromCart}
                        riskQuotations={risk_quotations}
                      />
                    )}
                  </React.Fragment>
                ))}
              </RiskContainer>
              {quoteTypes.map((type, index) => (
                <MalattiaModal
                  insuranceRequest={requestInfo}
                  type={type}
                  key={index}
                  addingQuote={addingQuote}
                  quotations={quotes}
                  selectQuotation={selectQuotation}
                  refresh={refresh}
                  processingQuote={processingQuote}
                />
              ))}
            </>
          )}
      </div>

    </Layout>
  );
}

export default BackofficeMalattiaQuotes;
